// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "button-10bHW";
var _3 = "disabled-10jr-";
var _4 = "inverted-3wHNf";
var _5 = "active-3o9To";
var _6 = "uppercase-36y4N";
var _7 = "icon-vaKpi";
var _8 = "common-3zWAf";
var _9 = "small-2zRao";
var _a = "large-21GHE";
export { _1 as "__esModule", _2 as "button", _3 as "disabled", _4 as "inverted", _5 as "active", _6 as "uppercase", _7 as "icon", _8 as "common", _9 as "small", _a as "large" }
export default { "__esModule": _1, "button": _2, "disabled": _3, "inverted": _4, "active": _5, "uppercase": _6, "icon": _7, "common": _8, "small": _9, "large": _a }
